import { render } from "./AddHsCodeModal.vue?vue&type=template&id=6a79505e&scoped=true&ts=true"
import script from "./AddHsCodeModal.vue?vue&type=script&lang=ts"
export * from "./AddHsCodeModal.vue?vue&type=script&lang=ts"

import "./AddHsCodeModal.vue?vue&type=style&index=0&id=6a79505e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-pim-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a79505e"]])

export default __exports__